import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { hasAnySim } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta07Model } from './model-consultaSeguimentoPergunta07'
import { isPergunta07OlharParaAllNao } from './utils-consultaSeguimentoPergunta07'

export const validatorConsultaSeguimentoPergunta07 = createValidator<ConsultaSeguimentoPergunta07Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_07_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta07Model, errors: ErrorObject<ConsultaSeguimentoPergunta07Model>) => {
    if (hasAnySim(values?.PERGUNTA_07_OLHAR_PARA)) {
      if (values.PERGUNTA_07_APONTA_COM_DEDO === SimNaoEnum.SIM) {
        errors.PERGUNTA_07_APONTA_POR = required(values?.PERGUNTA_07_APONTA_POR)
      }
      errors.PERGUNTA_07_APONTA_COM_DEDO = required(values?.PERGUNTA_07_APONTA_COM_DEDO)
    } else if (!isPergunta07OlharParaAllNao(values?.PERGUNTA_07_OLHAR_PARA)) {
      errors.PERGUNTA_07_OLHAR_PARA = 'Deve responder sim para algum ou não para todos'
    }
    return errors
  }
)
